module.exports = __WEBPACK_EXTERNAL_MODULE__ux_checkbox__;